// src/components/Skills/skills.js

import React from "react";

import WebDesign from "../../assets/vscode.webp";
import SEO from "../../assets/seo.png";
import UIDesign from "../../assets/ui-desing.webp";
import AppDesign from "../../assets/ai-icon.webp";
import MediaDesign from "../../assets/Musiikki_media.webp";

import {
  t as translate,
  normalizeLang,
  getLangFromPathname,
} from "../../i18n";
import { useSiteContent } from "../../content/SiteContentContext";

const skillsData = [
  { id: "web", img: WebDesign, link: "#works" },
  { id: "seo", img: SEO, link: "#works" },
  { id: "uiux", img: UIDesign, link: "#works" },
  { id: "ai", img: AppDesign, link: "#works" },
  { id: "media", img: MediaDesign, link: "#works" },
];

const Skills = ({ lang: langProp } = {}) => {
  const siteContent = useSiteContent();
  const skillMedia = siteContent?.media?.skills || {};

  // Home välittää normaalisti kielen propina.
  // Jos komponenttia käytetään ilman sitä, päätellään kieli URL:sta.
  const pathname =
    typeof window !== "undefined"
      ? window.location.pathname
      : "/";

  const lang =
    typeof langProp === "string" && langProp
      ? normalizeLang(langProp)
      : getLangFromPathname(pathname);

  const t = (key, vars) => translate(key, lang, vars);

  // Säilytetään oikea kieliprefixi myös silloin, kun verkkosivukortti
  // vie etusivun ankkurin sijaan yrityslanderille.
  const languagePrefix = lang === "en" || lang === "es" ? `/${lang}` : "";

  const resolvedSkillsData = skillsData.map((skill) => ({
    ...skill,
    img: skillMedia[skill.id] || skill.img,
    link:
      skill.id === "web"
        ? `${languagePrefix}/verkkosivut-yrityksille/`
        : skill.link,
  }));

  return (
    <section
      id="skills"
      className="mx-auto w-full scroll-mt-24 px-2 pb-24 sm:px-4 md:px-6 lg:px-12 xl:px-16"
      aria-label={t("skills.ariaLabel")}
    >
      <div className="mx-auto w-full max-w-6xl">
        <div className="rounded-[2rem] border border-black/10 bg-white/70 px-6 py-8 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:px-10 md:py-10">
          {/* Otsikko */}
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-black/50 dark:text-white/45">
              {t("skills.eyebrow") === "skills.eyebrow" ? "Osaaminen" : t("skills.eyebrow")}
            </p>

            <h2 className="mt-3 text-3xl font-bold text-black dark:text-white md:text-4xl">
              {t("skills.title")}
            </h2>

            <p className="mx-auto mt-4 max-w-2xl text-base font-light leading-relaxed text-black/75 dark:text-white/75 md:text-lg">
              {t("skills.lead")}
            </p>
          </div>

          {/* Kortit */}
          <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            {resolvedSkillsData.map((skill) => (
              <a
                key={skill.id}
                href={skill.link}
                className="group flex h-full flex-col rounded-2xl border border-black/10 bg-white/80 px-5 py-5 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5"
              >
                <div className="flex items-center gap-4">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-black/10 bg-black/[0.04] dark:border-white/10 dark:bg-white/5">
                    <img
                      src={skill.img}
                      alt=""
                      className="h-full w-full object-cover"
                      loading="lazy"
                      aria-hidden="true"
                    />
                  </div>

                  <h3 className="text-lg font-bold leading-snug text-black transition group-hover:text-lime-600 dark:text-white dark:group-hover:text-lime-400">
                    {t(`skills.cards.${skill.id}.title`)}
                  </h3>
                </div>

                <p className="mt-4 text-sm leading-relaxed text-black/70 dark:text-white/70 md:text-base">
                  {t(`skills.cards.${skill.id}.desc`)}
                </p>

                <div className="mt-auto pt-6">
                  <span className="inline-flex items-center font-bold text-black transition group-hover:translate-x-1 dark:text-white">
                    {t("skills.seeExamples")} →
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;